"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _pointsExchange = require("../clients/points-exchange");
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
const {
  INITIAL,
  LOADING,
  SUCCESS,
  FAILED
} = _constants.API_STATE;

/**
 * Promo page store
 */
let PointsExchangeProductSearchStore = (_dec = _mobx.action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  function PointsExchangeProductSearchStore(initialState = {}) {
    (0, _classCallCheck2.default)(this, PointsExchangeProductSearchStore);
    (0, _initializerDefineProperty2.default)(this, "API_STATE", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "error", _descriptor3, this);
    /**
     * get points exchange amounts options
     * @param {object} prop
     * @param {string} prop.payload
     * @param {string} prop.payload.source
     * @param {string} prop.payload.target
     * @param {string} prop.payload.displayType
     * @param {Function} [prop.successHandler]
     * @param {Function} [prop.errorHandler]
     */
    (0, _initializerDefineProperty2.default)(this, "fetch", _descriptor4, this);
    this.updateInitialState(initialState);
  }
  (0, _createClass2.default)(PointsExchangeProductSearchStore, [{
    key: "amounts",
    get: function () {
      return this.data.options || [];
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "onSuccess",
    value:
    /**
     * handle success
     * @this {Object} response
     * @this {Function} successHandler
     */
    function onSuccess(response, successHandler) {
      this.data = response;
      this.API_STATE = SUCCESS;
      successHandler === null || successHandler === void 0 ? void 0 : successHandler(response);
    }

    /**
     * handle error
     * @this {Object} error
     * @this {Function} errorHandler
     */
  }, {
    key: "onError",
    value: function onError(error, errorHandler) {
      var _error$response;
      const errorData = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data;
      this.error = errorData;
      this.API_STATE = FAILED;
      errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(errorData);
    }
  }]);
  return PointsExchangeProductSearchStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return INITIAL;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "error", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "amounts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "amounts"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fetch", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* ({
      source,
      target,
      displayType,
      errorHandler = () => null,
      successHandler = () => null
    }) {
      this.API_STATE = LOADING;
      try {
        const response = yield _pointsExchange.PointsExchangeClient.getAmounts(source, target, displayType);
        this.onSuccess(response, successHandler);
      } catch (error) {
        this.onError(error, errorHandler);
      }
    });
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype)), _class));
exports.default = PointsExchangeProductSearchStore;